<template>
	<div id="bottomLeft">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">售后服务</span>
				</div>
			</div>
			<div class="d-flex jc-around" style="height: 80%;">
				<div class="text d-flex flex-column jc-around" style="width: 40%;">
					<div>
						<p>处理中工单<br><span style="color: #F76E11;">{{ handing }}</span>/个</p>
						<p class="mt-3">已完成工单<br><span style="color: #2FDD92;">{{ finished }}</span>/个</p>
					</div>
				</div>
				<div class="text" style="width: 60%;">
					<dv-water-level-pond :config="config" style="width:1.875rem;height:1.875rem;margin: 0 auto;" />
					<!-- <div id="bottomLeftChart" style="width:1.875rem;height:1.875rem;margin: 0 auto;"></div> -->
					<p class="mt-1">当前完成</p>
				</div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<!-- <script src='./../../utils/echarts/echarts.js'></script>
<script src='./../../utils/echarts/echarts-liquidfill.js'></script> -->
<script>
	export default {
		data() {
			return {
				config: {
					data: [],
					shape: 'round',
					waveNum: 2,
					waveHeight: 10,
					waveOpacity: 0.8,
					colors: ['#00BAFF', '#3DE7C9']
				},
				handing: '',
				finished: '',
			};
		},
		components: {

		},
		mounted() {
			this.workflowCount();
		},
		methods: {
			async workflowCount() {
				await this.$axios.get("/api/buildings/workflowCount").then(res => {
					this.handing = res.data.data.handing;
					this.finished = res.data.data.finished;
					this.config = {
						data: [(res.data.data.finished / res.data.data.sum * 100).toFixed()],
						shape: 'round',
						waveNum: 2,
						waveHeight: 10,
						waveOpacity: 0.8,
						colors: ['#00BAFF', '#3DE7C9']
					}

					// this.chart = this.$echarts.init(
					// 	document.getElementById("bottomLeftChart")
					// )
					// var option = {
					// 	series: [{
					// 		type: 'liquidFill',
					// 		data: [0.6]
					// 	}]
					// };
					// this.chart.setOption(option);
				})
			},
		},
	};
</script>

<style lang="scss">
	#bottomLeft {
		height: 3.175rem;
		width: 5.125rem;

		.dv-water-pond-level canvas {
			margin-left: 0 !important;
		}

		.text {
			text-align: center;

			p {
				font-size: 0.1875rem;
				color: white;
				line-height: 0.3125rem;
			}

			span {
				display: inline-block;
				width: 0.625rem;
				font-size: 0.275rem;
			}
		}
	}
</style>
